// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"02b7b771","16":"87346447","300":"9354f84b","453":"127be8e2","597":"450d3990","890":"f87e6e0b","915":"1be4bdad","975":"07c635b1"}[chunkId] + ".chunk.js";
};